import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const Rating = ({
  width = 24,
  height = 24,
  className,
  color,
  decorative = false,
  ariaLabel = "Rating",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 24 24"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path d="M12,1.7L9.5,9.2H1.6L8,13.9l-2.4,7.6l6.4-4.7l6.4,4.7L16,13.9l6.4-4.7h-7.9L12,1.7z" />
    </svg>
  );
};
